exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal form{min-height:238px}.modal .btn.btn-arrow{min-width:140px}.modal .btn-outline-secondary+.btn-arrow{margin:auto;margin-right:0}", ""]);

// exports
